import _ from 'lodash';
import { takeEvery } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { flashMessage } from '../actions';
import { DATA_LOAD_ERROR } from '../constants/actionTypes';

const delay = ms => (
    new Promise(resolve => {
        setTimeout(() => resolve(), ms);
    })
);

function *handleFlashMessage(id, messageId, titleId='', ttl = 4000, theme = 'error' , params) {
    yield put(flashMessage.set(id,messageId, titleId, theme, ttl, params));
    yield delay(ttl);
    yield put(flashMessage.remove(id));
}

function *_handleHttpErrorCode({body, response, titleId}) {
    let errorCode = `serverError.${response && response.status}`;
    yield handleFlashMessage(response && response.statusText,errorCode);
}
function *_handleInterceptedError({body, response, titleId}) {
    let errorCode = `serverError.${response.status}`;
    yield handleFlashMessage(response.statusText,errorCode, titleId);
}
function *_handleServerError({body:{errors},titleId}) {
    yield _.map(errors, error => {
        return handleFlashMessage(`serverError.${error.code}`, `serverError.${error.code}`, titleId, undefined, undefined, error.params);
    });
}

function *_handleServerErrors({payload:{resource,error}}) {

    if (!error.body) {
        yield _handleHttpErrorCode(error);
    } else if (!error.body.errors) {
        yield _handleInterceptedError(error);
    } else {
        yield _handleServerError(error);
    }
}


export function *flashMessageOnServerError() {
    yield takeEvery(DATA_LOAD_ERROR, _handleServerErrors);
}
